import React from 'react';

const WarningIconV2 = ({
  className,
  style,
  active
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.2586 3.37533L9.30859 0.516992C8.50026 0.0503255 7.50026 0.0503255 6.68359 0.516992L1.74193 3.37533C0.933593 3.84199 0.433594 4.70866 0.433594 5.65033V11.3503C0.433594 12.2837 0.933593 13.1503 1.74193 13.6253L6.69193 16.4837C7.50026 16.9503 8.50026 16.9503 9.31693 16.4837L14.2669 13.6253C15.0753 13.1587 15.5753 12.292 15.5753 11.3503V5.65033C15.5669 4.70866 15.0669 3.85033 14.2586 3.37533ZM7.37526 4.95866C7.37526 4.61699 7.65859 4.33366 8.00026 4.33366C8.34193 4.33366 8.62526 4.61699 8.62526 4.95866V9.33366C8.62526 9.67533 8.34193 9.95866 8.00026 9.95866C7.65859 9.95866 7.37526 9.67533 7.37526 9.33366V4.95866ZM8.76693 12.3587C8.72526 12.4587 8.66693 12.5503 8.59193 12.6337C8.43359 12.792 8.22526 12.8753 8.00026 12.8753C7.89193 12.8753 7.78359 12.8503 7.68359 12.8087C7.57526 12.767 7.49193 12.7087 7.40859 12.6337C7.33359 12.5503 7.27526 12.4587 7.22526 12.3587C7.18359 12.2587 7.16693 12.1503 7.16693 12.042C7.16693 11.8253 7.25026 11.6087 7.40859 11.4503C7.49193 11.3753 7.57526 11.317 7.68359 11.2753C7.99193 11.142 8.35859 11.217 8.59193 11.4503C8.66693 11.5337 8.72526 11.617 8.76693 11.7253C8.80859 11.8253 8.83359 11.9337 8.83359 12.042C8.83359 12.1503 8.80859 12.2587 8.76693 12.3587Z",
      fill: "#B1B6C6"
    }
  )
);

export { WarningIconV2 };
//# sourceMappingURL=WarningIconV2.js.map
